import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import routes from '@/router/routes'
import { common } from '@/utils'
import { useCorpSettingStore } from '@/stores'

const usePageTitle = () => {
  const location = useLocation()
  const { corpSetting } = useCorpSettingStore()
  const { language } = corpSetting || {}
  
  useEffect(() => {
    common.changePageTitle(routes, location.pathname)
  }, [location, language])
}

export default usePageTitle
